import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ArrowDown = ({ viewBox, stroke, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 10 10'}>
    <path d="M8 6L15.7942 0H0.205771L8 6Z" fill="#070A0D" />
  </BaseIcon>
);

export default ArrowDown;
